// Discovery only. The server independently checks persisted identity, role,
// policy and clock for every operation. This module never grants permissions.
export const MERCURY_TRIAL_TENANT = '1KAV4fFiYOc3dPNCwzeT';
export function customerTrialStatus(tenantId, tenant, now = Date.now()) {
  if (tenantId !== MERCURY_TRIAL_TENANT) return 'legacy';
  if (!tenant || tenant.id !== tenantId) return 'unavailable';
  if (tenant.customerTrial === undefined) return 'legacy';
  const trial = tenant.customerTrial;
  if (!trial || typeof trial !== 'object' || !Number.isSafeInteger(now)
      || !Number.isSafeInteger(trial.endsAt) || !Array.isArray(trial.features)) return 'unavailable';
  if (now >= trial.endsAt) return 'expired';
  return trial.active === true ? 'active' : 'unavailable';
}
export function hasCustomerTrialFeature(tenantId, tenant, feature, now = Date.now()) {
  return customerTrialStatus(tenantId, tenant, now) === 'active'
    && tenant.customerTrial.features.includes(feature);
}
